<template>
  <div class="card">
    <div class="card-header">Quiz Info</div>
    <div class="card-body">
      <div class="mb-1" v-if="quiz.name">
        {{ quiz.name }}
        <HostBadge v-bind:hostName="quiz.host" />
      </div>
      <div class="mb-1" v-if="noTeam == false && teamName">
        Playing as
        <TeamBadge v-bind:teamName="teamName" prefix />
      </div>
      <div class="mb-2 mt-2" v-if="quiz.link_to_stream">
        <a v-bind:href="quiz.link_to_stream" target="_blank">
          <b-icon-box-arrow-up-right variant="primary" class="mr-1" />Open video
          stream
        </a>
      </div>
      <div class="mb-1">
        Viewed by
        <b-icon-eye-fill />
        {{ viewCount }}
      </div>
      <div v-if="quizEnded">This quiz has ended!</div>
    </div>
  </div>
</template>

<script>
import HostBadge from "@/components/HostBadge";
import TeamBadge from "@/components/TeamBadge";
import { mapGetters } from "vuex";

export default {
  name: "QuizInfo",
  props: {
    quizID: {
      default: 0
    },
    noTeam: {
      default: false
    }
  },
  components: {
    HostBadge,
    TeamBadge
  },
  data() {
    return {
      quiz: {},
      teamName: ""
    };
  },
  computed: {
    ...mapGetters("teamStore", { activeTeamID: "activeTeamID" }),
    quizEnded() {
      return this.quiz.status >= this.$tqConstants["QUIZ_STATUS_ENDED"];
    },
    viewCount() {
      var info = this.$store.state.viewerInfo[this.quizID];
      if (info) {
        return info;
      } else {
        return 0;
      }
    }
  },
  created() {
    // needs to be triggered by parent
    this.$topquiz.on(this, "getQuizData_success", params => {
      this.quiz = params[0];
    });

    this.$topquiz.on(this, "getTeamData_success", params => {
      this.teamName = params[1];
    });

    this.$topquiz.on(this, "quizStreamUrlChanged", params => {
      if (params[0] == this.quiz.id) {
        this.quiz.link_to_stream = params[1];
      }
    });

    this.$topquiz.on(this, "quizNameChanged", params => {
      if (params[0] == this.quiz.id) {
        this.quiz.name = params[1];
      }
    });

    this.$topquiz.on(this, "quizStatusChanged", params => {
      if (params[0] == this.quiz.id) {
        this.quiz.status = params[1];
      }
    });

    this.$topquiz.sendCommand(
      "getTeamData",
      this.$topquiz.SessionKey,
      this.activeTeamID
    );

    this.$topquiz.sendCommand("subscribe-meta", this.quizID);
  },
  destroyed() {
    this.$topquiz.sendCommand("unsubscribe-meta", this.quizID);
    this.$topquiz.unsubscribe(this);
  }
};
</script>
